<template>
  <div class="page fleet">
    <h1>Wagenpark
      <button class="sync" @click="fetchFleet" title="Synchroniseer">
        <fa-icon icon="sync-alt"></fa-icon>
    </button>
    </h1>
    <div class="fleet__controls">
      <button class="button button--accept" @click="newVisible=true">+ Nieuw voertuig</button>
    </div>
    <div class="page__content">
      <Loader v-if="isLoading"></Loader>
      <div class="cardlist" v-else>
        <div class="cardlist__item" v-for="item in fleet" :key="`fleet--${item.ID}`">
          <div class="cardlist__item__thumb">
            <img :src="`${imgRoot}${item.FOTO}`" :alt="item.NAAM">
          </div>
          <div class="cardlist__item__content">
            <h2>{{item.MERK}}</h2>
            <h3>{{item.MODEL}}</h3>
            <p>pax: <b>{{item.PLAATSEN}}</b></p>
            <p>Nummerplaat: <b>{{item.PLAAT}}</b></p>
            <div class="cardlist__item__content__controls">
              <button class="button" @click="editItem=item"><fa-icon icon="edit"></fa-icon></button>
              <button class="button button--cancel" @click="deleteItem=item"><fa-icon icon="trash-alt"></fa-icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FleetNew v-if="newVisible" @close-modal="newVisible=false" @data-edit="onUpdate" @preview-click="onPreviewClicked"></FleetNew>
    <FleetEdit v-if="editItem" @close-modal="editItem=null" :item="editItem" :fileRoot="imgRoot" @data-edit="onUpdate" @preview-click="onPreviewClicked"></FleetEdit>
    <FleetDelete v-if="deleteItem" @close-modal="deleteItem=null" @delete-decline="deleteItem=null" @delete-confirm="deleteItemConfirm"></FleetDelete>
    <AssetModal v-if="previewAsset" :asset="previewAsset" @close-asset="previewAsset=null"></AssetModal>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import AssetModal from "@/components/AssetModal";
import SubcontractorService from "@/services/subcontractor";

import FleetNew from "@/components/Fleet/FleetNew";
import FleetEdit from "@/components/Fleet/FleetEdit";
import FleetDelete from "@/components/Fleet/FleetDelete";

export default {
  name: "Fleet",
  components: {
    Loader,
    AssetModal,
    FleetNew,
    FleetEdit,
    FleetDelete
  },
  data() {
    return {
      isLoading: false,

      editItem: null,
      newVisible: false,
      deleteItem: null,

      previewAsset: null,

      fleet: []
    };
  },
  created() {
    this.fetchFleet();
  },

  computed:{
    imgRoot(){
      return `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/media/partners/`;
    }
  },

  methods:{
    fetchFleet(){
      this.isLoading = true;
      SubcontractorService.getFleet(this.$store.state.auth.user.PERS_ID)
        .then(res => {
          if (res.status && res.data) {
            this.fleet = res.data;
          }
          this.isLoading = false;
        })
    },
    deleteItemConfirm(){
      SubcontractorService.deleteVehicle(this.deleteItem.ID)
      .then(res =>{
        if(res){
         this.onUpdate();
        }
      });
    },

    onUpdate(){
      this.deleteItem = null;
      this.editItem = null;
      this.newVisible = null;
      this.fetchFleet();
    },

    onPreviewClicked(asset){
      this.previewAsset=asset;
    }
  }
}
</script>
